import React from "react";

export default function HowToReachRajgir() {
  return (
    <div className="travel-guide-container">
      {/* Card displaying the entire travel information */}
      <div className="travel-card">
        <h2 className="travel-title">राजगीर कैसे पहुँचें</h2>

        <p className="card-description">
          <strong>
            राजगीर एक प्राचीन शहर है, जिसे मूल रूप से राजगृह के नाम से जाना जाता
            था, जो नालंदा से लगभग 15 किमी दूर स्थित है। यह बौद्ध धर्म, जैन धर्म
            और प्राचीन भारतीय इतिहास में ऐतिहासिक महत्व रखता है। यहाँ बताया गया
            है कि आप विभिन्न परिवहन माध्यमों से राजगीर कैसे पहुँच सकते हैं:
          </strong>
        </p>

        <h3 className="section-title">1. निकटतम हवाई अड्डा</h3>
        <ul className="card-list">
          <li style={{ listStyle: "auto" }}>
            <strong>जय प्रकाश नारायण अंतर्राष्ट्रीय हवाई अड्डा (पटना)</strong> –
            राजगीर से लगभग 100 किमी दूर।
            <ul>
              <li style={{ listStyle: "outside" }}>
                <em>हवाई अड्डे से:</em> आप पटना से राजगीर के लिए टैक्सी या बस ले
                सकते हैं। सड़क मार्ग से राजगीर पहुंचने में लगभग 2.5 से 3 घंटे
                लगते हैं।
              </li>
            </ul>
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>गया अंतर्राष्ट्रीय हवाई अड्डा (गया)</strong> – राजगीर से
            लगभग 69 किमी दूर।
            <ul>
              <li style={{ listStyle: "outside" }}>
                <em>हवाई अड्डे से:</em> आप गया से राजगीर के लिए टैक्सी या बस ले
                सकते हैं। सड़क मार्ग से इसमें लगभग 1.5 से 2 घंटे लगते हैं।
              </li>
            </ul>
          </li>
        </ul>

        <h3 className="section-title">2. ट्रेन से</h3>
        <ul className="card-list">
          <li style={{ listStyle: "auto" }}>
            <strong>राजगीर रेलवे स्टेशन:</strong> शहर के भीतर स्थित, यह पटना,
            गया और नालंदा जैसे प्रमुख शहरों से जुड़ा हुआ है।
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>गया जंक्शन:</strong> राजगीर से लगभग 78 किमी दूर। यह भारत के
            प्रमुख शहरों से अच्छी तरह से जुड़ा हुआ है।
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>पटना जंक्शन:</strong> राजगीर से लगभग 100 किमी दूर। यह एक
            प्रमुख रेलवे हब है जहाँ से भारत के विभिन्न हिस्सों के लिए नियमित
            ट्रेनें चलती हैं।
          </li>
          <li style={{ listStyle: "auto" }}>
            <em>पटना/गया से:</em> आप इन स्टेशनों से राजगीर के लिए लोकल ट्रेन या
            बस ले सकते हैं।
          </li>
        </ul>

        <h3 className="section-title">3. सड़क मार्ग से</h3>
        <ul className="card-list">
          <li style={{ listStyle: "auto" }}>
            राजगीर, बिहार और पड़ोसी राज्यों के प्रमुख शहरों से सड़क मार्ग द्वारा
            अच्छी तरह से जुड़ा हुआ है।
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>पटना से:</strong> दूरी लगभग 100 किमी है। आप बस, टैक्सी या
            अपनी गाड़ी से पटना-बिहार शरीफ-राजगीर सड़क मार्ग से जा सकते हैं,
            जिसमें लगभग 2.5 से 3 घंटे लगते हैं।
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>गया से:</strong> दूरी लगभग 78 किमी है, और सड़क मार्ग से
            इसमें लगभग 2 घंटे लगते हैं।
          </li>
        </ul>

        <h3 className="section-title">4. बस से</h3>
        <ul className="card-list">
          <li style={{ listStyle: "auto" }}>
            पटना, गया और नालंदा से राजगीर के लिए नियमित बसें चलती हैं। बिहार
            राज्य पर्यटन विकास निगम (BSTDC) भी पर्यटकों के लिए बस सेवाएं प्रदान
            करता है।
          </li>
          <li style={{ listStyle: "auto" }}>
            <strong>पटना या गया से:</strong> बस से लगभग 2-3 घंटे लगते हैं।
          </li>
        </ul>

        <p className="conclusion-text">
          अपनी सुविधानुसार परिवहन का साधन चुनें और राजगीर के ऐतिहासिक आकर्षणों
          का पता लगाएं।
        </p>
      </div>
    </div>
  );
}
